import { render, staticRenderFns } from "./contactUsDialog.vue?vue&type=template&id=54ecc5ae&scoped=true"
import script from "./contactUsDialog.vue?vue&type=script&lang=js"
export * from "./contactUsDialog.vue?vue&type=script&lang=js"
import style0 from "./contactUsDialog.vue?vue&type=style&index=0&id=54ecc5ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ecc5ae",
  null
  
)

export default component.exports